<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

html,body{

font-family: 'Noto Kufi Arabic', sans-serif;

}

</style>



// WEBPACK FOOTER //
// src/App.vue